import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M15 3v2c0 .552-.448 1-1 1s-1-.448-1-1V3h-2c-.552 0-1-.448-1-1s.448-1 1-1h2c1.105 0 2 .895 2 2zM3 3v2c0 .552-.448 1-1 1s-1-.448-1-1V3c0-1.105.895-2 2-2h2c.552 0 1 .448 1 1s-.448 1-1 1H3zM13 13v-2c0-.552.448-1 1-1s1 .448 1 1v2c0 1.105-.895 2-2 2h-2c-.552 0-1-.448-1-1s.448-1 1-1h2zM3 13h2c.552 0 1 .448 1 1s-.448 1-1 1H3c-1.105 0-2-.895-2-2v-2c0-.552.448-1 1-1s1 .448 1 1v2z"
        />
        <rect width="14" height="2" x="1" y="7" className="icon-color" rx="1" />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          fillRule="nonzero"
          d="M22 4v4c0 .552-.448 1-1 1s-1-.448-1-1V4h-4c-.552 0-1-.448-1-1s.448-1 1-1h4c1.105 0 2 .895 2 2zM4 4v4c0 .552-.448 1-1 1s-1-.448-1-1V4c0-1.105.895-2 2-2h4c.552 0 1 .448 1 1s-.448 1-1 1H4zM20 20v-4c0-.552.448-1 1-1s1 .448 1 1v4c0 1.105-.895 2-2 2h-4c-.552 0-1-.448-1-1s.448-1 1-1h4zM4 20h4c.552 0 1 .448 1 1s-.448 1-1 1H4c-1.105 0-2-.895-2-2v-4c0-.552.448-1 1-1s1 .448 1 1v4z"
        />
        <rect
          width="20"
          height="2"
          x="2"
          y="11"
          className="icon-color"
          rx="1"
        />
      </g>
    </svg>
  ),
};
